import { render, staticRenderFns } from "./MultiOrderableProfessionListSelector.vue?vue&type=template&id=5b9e9dba&scoped=true&"
import script from "./MultiOrderableProfessionListSelector.vue?vue&type=script&lang=ts&"
export * from "./MultiOrderableProfessionListSelector.vue?vue&type=script&lang=ts&"
import style0 from "./MultiOrderableProfessionListSelector.vue?vue&type=style&index=0&id=5b9e9dba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9e9dba",
  null
  
)

export default component.exports